 <app-type-voie  [uid]="getUid()" [parentForm]="parentForm" [voie]="lieuExecutionLivraison?.voie" [disabled]="disabled"
 [rule]="rule" [errorMessage]="errorMessage"></app-type-voie>

<app-form-input
    [parentForm]="parentForm"
    [value]="lieuExecutionLivraison?.cp"
    [label]="step2.getcp"
    [disabled]="disabled"
    [type]="'text'"
    [rule]="'required|pattern_3'"
    [errorMessage]="errorMessage"
    [name]="getUid()+'_SepAtt_cp'">
</app-form-input>

<app-form-input
    [parentForm]="parentForm"
    [value]="lieuExecutionLivraison?.ville"
    [id]="'ville_0_'+getUid()"
    [label]="step2.getville"
    [disabled]="disabled"
    [type]="'text'" [rule]="'required'"
    [errorMessage]="errorMessage"
    [name]="getUid()+'_SepAtt_ville'">
</app-form-input>
